
export class I3AssetsDown {
    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            if (json.value) this.value = json.value.map(a => new I3AssetDown(a));
        }
    }

    value: I3AssetDown[] = [];
}

export class I3AssetDown {
    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);
        }
    }

    assetCode: string;
    description: string;
    locationId: number;
    locationName: string;
}
